import React from 'react';
import classnames from 'classnames';
import {
  laTimes,
  forbes,
  sfWeekly,
  techCrunch,
  businessInsider
} from './styles.mod.scss';

function Media({ className }) {
  return (
    <div className={classnames('row center-xs middle-xs around-md', className)}>
      <span className={laTimes} />
      <span className={forbes} />
      <span className={sfWeekly} />
      <span className={techCrunch} />
      <span className={businessInsider} />
    </div>
  );
}

export default Media;
